import toInteger from 'lodash/toInteger'
import { reject, join, toLower, pipe, replace, propEq, defaultTo } from 'ramda'
import CurrencyFormatter from '@/components/currency-formatter'
import i18n from '@/i18n'
import { isFalsy } from '@/utils'
import { sqftToMeter } from './units'

const BUILDING_TYPE = {
  condo: 'apartment',
  highrise: 'apartment',
  lowrise: 'apartment',
  house: 'house',
  townhouse: 'townhouse'
}

export const getPaymentFrequency = key => {
  const PAYMENT_FREQUENCY = {
    daily: i18n.t('b.listing.view.price_frequency_daily.text', 'Day'),
    weekly: i18n.t('b.listing.view.price_frequency_weekly.text', 'Week'),
    monthly: i18n.t('b.listing.view.price_frequency_monthly.text', 'Month'),
    one_time: i18n.t('b.listing.view.price_frequency_one_time.text', 'Single payment')
  }
  return PAYMENT_FREQUENCY[key]
}

export const getUrl = (listing = {}) =>
  join('/', [
    '/rental-listings/detail',
    BUILDING_TYPE[listing.building_type] || 'apartment',
    pipe(defaultTo(''), toLower, replace(' ', '-'))(listing?.city),
    listing?.listing_id
  ])

export const isGroup = propEq('gr_unit', '1')

export const prefixUnitNumber = unitNumber => {
  if (unitNumber) {
    return unitNumber
  }
  return ''
}

export const parseAreaSize = (sizeInSqft, targetFormat) =>
  targetFormat === 'meter' ? toInteger(sqftToMeter(sizeInSqft)) : sizeInSqft

export const getAreaMeasurementLabel = format => (format === 'meter' ? 'm²' : 'ft²')

export const formatListingPrice = price => {
  return price ? <CurrencyFormatter value={price} /> : 'N/A'
}

export const renderListingPrice = listing => {
  const { gr_unit, gr_min_price, gr_max_price, price } = listing
  return gr_unit === '1' ? (
    <>
      {formatListingPrice(gr_min_price)} - {formatListingPrice(gr_max_price)}
    </>
  ) : (
    formatListingPrice(price)
  )
}

export const formatAddress = address => {
  const unit = address.unit_number ? `${address.unit_number} - ` : ''
  const rest = pipe(
    reject(isFalsy),
    join(', ')
  )([address.full_street_name, address.city, address.state, address.zip?.toUpperCase()])
  return `${unit}${rest}`
}

export const FormattedAddress = ({ listing }) => {
  const unit = listing.unit_number ? `${listing.unit_number} - ` : ''
  const rest = pipe(
    reject(isFalsy),
    join(', ')
  )([listing.full_street_name, listing.city, listing.state])
  const zip = <span style={{ whiteSpace: 'nowrap' }}>{listing.zip?.toUpperCase()}</span>
  return (
    <span>
      {`${unit}${rest}, `}
      {zip}
    </span>
  )
}
